'use strict'

define ['./profile.scss'], () ->
  ($scope, $http, RentappService, RENTAPPLICATION_API_URL, $state, Flash, landlord, $window, $uibModal, $cacheFactory) ->
    $scope.landlord = landlord

    if $scope.landlord.logo
      $scope.filename = $scope.landlord.logo

    $scope.update_profile = (landlord) ->
      if not $scope.profileForm.$valid
        return

      $scope.saving_settings = true
      $http.patch "#{RENTAPPLICATION_API_URL}#{landlord.resource_uri}",
        name: landlord.name
        contact_email: landlord.contact_email
        website: landlord.website
        phone: landlord.phone
        company_name: landlord.company_name
        address: landlord.address
        landlord_emails: landlord.landlord_emails
        logo: landlord.logo
      .then ->
        $cacheFactory.get('$http').removeAll()
        Flash.clear()
        Flash.create('success', 'Profile settings successfully updated.', 3000, {class: 'profile-success'}, true)
        $window.scrollTo(0, 0);
      .catch (resp, code) ->
         if resp.status == 400
           _.forEach resp.data.landlord, (key, val) ->
              Flash.clear()
              Flash.create("danger", val + ' - ' + key, 3000, { class: 'error' }, true)
         else
           Flash.clear()
           Flash.create("danger", "Something went wrong", 3000, { class: 'error' }, true)
         $window.scrollTo(0, 0);
      .finally () ->
        $scope.saving_settings = false

    $scope.open_modal = () ->
      $uibModal.open
        scope: $scope
        controller: require('./../../../../directives/closeAccountModal/closeAccountModal.coffee')
        template: require("./../../../../directives/closeAccountModal/closeAccountModal.jade")
      .result.then () ->
        $cacheFactory.get('$http').removeAll()



// WEBPACK FOOTER //
// ./components/dashboard/settings/profile/profile.coffee